// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import Plupload from "src/modules/Plupload/jsx/Plupload.js";
import { sendXHR, failedRequest } from "src/lib/utils";
import { gu_auth } from "src/lib/authentication.js";
import { setStorage } from "src/lib/storage.js";

// Stateful components

export class UserProfile extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {};

        // Binds
        this.openAvatarEditor = this.openAvatarEditor.bind(this);
        this.deleteProfileImage = this.deleteProfileImage.bind(this);
        this.refreshImageData = this.refreshImageData.bind(this);
    }


    // 
    // Events
    //

    openAvatarEditor(event) {
        event.preventDefault();

        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var modal_content = this_component.renderModalContent();
        var modal_buttons = this_component.renderModalButtons();

        // Get modal data
        var modal_data = {
            'title': 'Edit my profile picture',
            'class': 'modal-profile',
            'content': modal_content,
            'buttons': modal_buttons
        };

        // Set modal content and display
        helpers.setModalContent(modal_data);
        portal_context['helpers']['closeMobileNav']();

        setTimeout(this_component.addFileInputLabel, 500);
    }


    //
    // Functions
    //

    getAvatarData(configuration) {
        var images = configuration['images'];

        // Default
        var default_avatar = images['default avatar'];

        // Gatekeeper API
        var app_config = configuration['portal_configuration']['AppConfig'];
        var gatekeeper_endpoint = app_config['apiRoot'];

        var image_keys = squiz.fn.getStorage('getimagekeys', 'session', 'json');

        // Default with default
        var image_data = default_avatar['url'];

        if(image_keys !== null) {
            var user_avatar = image_keys['data']['profile'];

            // Check for saved image
            if(typeof(user_avatar) !== 'undefined' && user_avatar !== null) {
                image_data = gatekeeper_endpoint + 'photostore/v1/fetch/' + user_avatar;
            }
        }

        return image_data;
    }

    getUserName() {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];
        var user_attributes = user_personalisation['attributes'];
        
        return user_attributes['NAME'];
    }

    getUserPrograms() {
        var my_courses = squiz.fn.getStorage('getmycourses', 'session', 'json');
        var programs = my_courses['data']['programs'];
        var program_names = [];

        programs.forEach(function(program, program_index){
            var program_name = program['name'];
            program_names.push(program_name);
        });
        
        return program_names;
    }

    deleteProfileImage() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];

        var app_config = configuration['portal_configuration']['AppConfig'];
        var gatekeeper_endpoint = app_config['apiRoot'];
        var delete_url = gatekeeper_endpoint + 'photostore/v1/profile';
        var token = gu_auth.fn.getActiveToken();

        var xhr_parameters = {
            'request_url': delete_url,
            'request_success': function(response) {
                this_component.refreshImageData(response);
            },
            'request_failure': failedRequest,
            'request_extras': ''
        };

        sendXHR(xhr_parameters, 'DELETE', token);
    }

    refreshImageData(response) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        if (response) {
            var image_data = {
                "timestamp": new Date().getTime(),
                "data": JSON.parse(response)
            };
            var storage_key = squiz['vars']['store_id'] + 'getimagekeys';
            setStorage('session', storage_key, image_data);
            helpers.refreshPage();
        }
    }

    addFileInputLabel() {
        var profile_upload = document.getElementById('plupload_profileUpload');
        if (profile_upload) {
            var input = profile_upload.querySelector('input[type="file"]');
            var input_id = input.getAttribute('id');
            var label = document.createElement('label');
            label.setAttribute('for', input_id);
            label.classList.add('visuallyhidden');
            label.innerHTML = 'Upload profile picture';
            var parent = document.getElementById(input_id + '_container');
            if (parent) {
                parent.appendChild(label);
            }
        }
        
    }


    //
    // Render
    //

    renderModalContent() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        
        var app_config = configuration['portal_configuration']['AppConfig'];
        var gatekeeper_endpoint = app_config['apiRoot'];
        var post_url = gatekeeper_endpoint + 'photostore/v1/profile';

        var image_keys = squiz.fn.getStorage('getimagekeys', 'session', 'json');
        var user_avatar = image_keys['data']['profile'];
        var has_avatar = user_avatar ? true : false;

        var upload_button = 
            <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23">
                <g fill="#C02424" fillRule="nonzero">
                    <path d="M3.2 3.8a.608.608 0 0 1-.6-.6V.8a.6.6 0 1 1 1.2 0v2.4a.608.608 0 0 1-.6.6zM23.2 19.8h-20a.608.608 0 0 1-.6-.6V5.6a.6.6 0 1 1 1.2 0v13h19.4a.6.6 0 0 1 0 1.2z"></path>
                    <path d="M20.8 22.2a.608.608 0 0 1-.6-.6v-2.4a.6.6 0 0 1 1.2 0v2.4a.608.608 0 0 1-.6.6zM20.8 17.4a.608.608 0 0 1-.6-.6v-13H.8a.6.6 0 1 1 0-1.2h20c.33.004.596.27.6.6v13.6a.608.608 0 0 1-.6.6zM17.6 19.8a.592.592 0 0 1-.424-.176L8.8 11.248l-5.176 5.176a.6.6 0 0 1-.848-.848l5.6-5.6a.6.6 0 0 1 .848 0l8.8 8.8A.6.6 0 0 1 17.6 19.8z"></path>
                    <path d="M20.8 17.4a.592.592 0 0 1-.424-.176L16.8 13.648l-1.976 1.976a.6.6 0 0 1-.848-.848l2.4-2.4a.6.6 0 0 1 .848 0l4 4A.6.6 0 0 1 20.8 17.4z"></path>
                </g>
            </svg>
            <span>Choose a file</span>
            </>
        ;

        return (
            <Plupload 
                id="profileUpload"
                classList="profile-upload"
                deleteProfileImage={this_component.deleteProfileImage}
                refreshImageData={this_component.refreshImageData}
                hasAvatar={has_avatar}
                flash_swf_url={configuration['plupload']['flash']}
                silverlight_xap_url={configuration['plupload']['silverlight']}
                multi_selection={false}
                autoUpload={true}
                url={post_url}
                buttonSelect={upload_button}
            />
        );   
    }

    renderModalButtons() {
        return (
            [{
                'class': 'btn btn-secondary',
                'label': 'Cancel',
                'clickHandler': null,
                'action': 'close'
            }]
        );
    }

    // Render profile avatar image
    renderUserAvatar() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];

        // Click handler
        var click_handler = this_component.openAvatarEditor;

        // Image data
        var image_data = this_component.getAvatarData(configuration);

        return (
            <a href="#" className="user-profile__edit" onClick={click_handler}>
                <img src={image_data} alt="Avatar" className="user-profile__img" />
            </a>
        );
    }

    renderUserInformation() {
        var this_component = this;
        var user_name = this_component.getUserName();
        var user_programs = this_component.getUserPrograms();

        var rendered_program_names = user_programs.map(function(program, program_index) {
            return <span key={program_index} className="user-profile__program">{program}</span>;
        });

        return (
            <div className="user-profile__info">
                <span className="user-profile__name">{user_name}</span>
                {rendered_program_names}
            </div>
        );
    }

    render() {
        var this_component = this;
        var user_avatar = this_component.renderUserAvatar();
        var user_information = this_component.renderUserInformation();

        return (
            <div id="main__profile" className="user-profile__wrapper">
                <div className="user-profile">
                    {user_avatar}
                    {user_information}
                </div>
            </div>
        );
    }

};

UserProfile.contextType = PortalContext;
